<template>
  <div class="load-more" :class="{clickable: !(disabled||loading), loading: loading}" @click="handleClick">
    <NouLoading v-if="loading" class="load-more__loading" />
    <div class="label g-font-bold">Load more{{ loading ? '...' : ''}}</div>
  </div>
</template>

<script>

export default {
  name: 'LoadMore',
  props: {
    loading: {
      type: Boolean,
      require: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  methods: {
    handleClick(e) {
      if (this.disabled || this.loading) {
        return;
      }
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
  .load-more {
    margin: 40px auto;
    position: relative;
    width: 240px;
    height: 44px;
    line-height: 44px;
    text-align: left;
    background: #F2F2F2;
    border-radius: 2px;
    transition: .5s background-color;
    font-size: 14px;
    overflow: hidden;

    &.clickable {
      cursor: pointer;
      &:hover {
        background: #E6E6E6;
      }
    }

    &.loading {
      background: transparent;
    }
  }

  .load-more__loading {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
  }

  .label {
    margin-left: 84px;
  }
</style>
